/*******************************************************************************
  설  명 : 협회소개 > 주요사업
  작성자 : 송영석
  작성일 : 2020-05-18
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule, NgbModal, NgbActiveModal, NgbModalOptions, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { Globals } from '@app/service/globals.service';
import { MemberListService } from '@app/home/service/member.list.service';


import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

import { MemberViewComponent } from '@home/page/member-info/member-list/member-view/member-view.component';

const options: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: 'lg',
  centered: true,
  windowClass:'modal-830'
};

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.scss']
})
export class MemberListComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/

  page = 1;
  public isSelectOn: boolean; //selectbox on
  public isSelectTxt = '전체'; // selectbox txt

  public search: any = {
    searchType: 'consonant', // word
    searchType1: 'all', // company, goods
    searchText: '',
    no: 1,
    row: 12,
  }

  public maxSize: any = 10;

  public data: any = [];
  public totalCount: any = 0;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private modalService: NgbModal,
    private memberListService: MemberListService,
    private globals: Globals
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    if ( window.innerWidth <= 720 ) {
      this.maxSize = 3;
    }
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.isSelectOn = false;

    this.activatedRoute.queryParams.subscribe(params => {
      this.search.searchType = ( typeof params.searchType == 'undefined' || params.searchType == '' ) ? 'consonant' : params.searchType;
      this.search.searchType1 = ( typeof params.searchType1 == 'undefined' || params.searchType1 == '' ) ? 'all' : params.searchType1;
      this.search.searchText = ( typeof params.searchText == 'undefined' || params.searchText == '' ) ? '' : params.searchText;
      this.search.row = ( typeof params.row == 'undefined' || params.row == '' ) ? '12' : params.row;
      this.search.no = ( typeof params.no == 'undefined' || params.no == '' ) ? '1' : params.no;

      this.getCompanyMemberList();
    });
  }

  /*******************************************************************************
    설  명 : 회원사 정보
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  openMember(item) {
    const modalRef = this.modalService.open(MemberViewComponent, options);

    modalRef.componentInstance.seq = item.seq;

    modalRef.result.then((result) => {
      if( result ) {
      }
    }, (reason) => {
    });
  }

  /*******************************************************************************
    설  명 : 회원사 현황 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getCompanyMemberList() {
    // indicator 표시 숨김
    setTimeout (() => {
      this.globals.indicator.next(true);
    });

    this.memberListService.getCompanyMemberList( this.search ).then( response => {
      if( response.ResultCode ) {
        this.data = response.data;
        this.totalCount = response.total;
      } else {
        this.data = [];
        this.totalCount = 0;
      }

      this.globals.indicator.next(false);
    });
  }

  /*******************************************************************************
    설  명 : 자음 검색
    입력값 : 자음
    리턴값 : 없음
  *******************************************************************************/
  searchClick( word ) {
    this.search.searchType = 'consonant';

    if( word == '기타' ) this.search.searchType1 = 'etc';
    else this.search.searchType1 = '';
    this.search.searchText = word;

    this.getCompanyMemberList();
  }

  /*******************************************************************************
    설  명 : 검색 콤보 박스 선택 시 처리
    입력값 : all, company, goods
    리턴값 : 없음
  *******************************************************************************/
  selectSearchType1( word ) {
    this.search.searchType1 = word;

    if( word == 'goods' ) this.isSelectTxt = '상품';
    else if( word == 'company' ) this.isSelectTxt = '회사';
    else this.isSelectTxt = '전체';
  }

  /*******************************************************************************
    설  명 : 검색 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  initSearch() {
    this.search = {
      searchType: 'consonant', // word
      searchType1: 'all', // company, goods
      searchText: '',
      no: 1,
      row: 12,
    };

    this.getCompanyMemberList();
  }

  /*******************************************************************************
    설  명 : 검색 input에서 엔터키 입력 시 검색 처리
    입력값 : $event
    리턴값 : 없음
  *******************************************************************************/
  searchList( event ) {
    if( event.key == 'Enter' ) {
      this.search.searchType = 'word';

      this.getCompanyMemberList();
    }
  }

  /*******************************************************************************
    설  명 : 단어 검색
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  searchWordList() {
    this.search.searchType = 'word';

    this.getCompanyMemberList();
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage( page ) {
    this.search.no = page;

    this.router.navigate(
    [location.pathname],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.search,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

}
